import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import phoneIcon from 'presentation/assets/icons/png/3x/icn-phone@3x-schwarz.png';
import {
  TechemModal,
  TechemModalBody,
  TechemModalButtonFooter,
  TechemModalHeader
} from '@techem/ui-components';
import { TrackerUtil } from 'tracking/TrackerUtil';
import { styled } from 'baseui';
import useContact from 'tools/hooks/useContact';
import { minBreakpoints } from 'presentation/theme/mediaQueries';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}
const Clickable = styled('span', {
  cursor: 'pointer'
});

const MultipleHousesModal: React.FC<Props> = ({ isOpen, setOpen }) => {
  const { t } = useTranslation();
  const modalId = 'modal-more-properties';
  const { openCall, openEmail } = useContact(modalId);
  const isMobile = useMediaQuery(`(max-width: ${minBreakpoints.sm}px)`);

  return (
    <TechemModal
      autoFocus={false}
      isOpen={isOpen}
      modalTrackingId={modalId}
      additionalTestId="multiple-properties"
      header={<TechemModalHeader title={t('ContactUsTitle')} src={phoneIcon} />}
      body={
        <TechemModalBody>
          <Row className="justify-content-center">
            <Col xs={12} className="copy text-center">
              <Trans i18nKey="ContactUsParagraph1HouseCountExceeded" parent="p" />
              <Trans
                i18nKey={isMobile ? 'ContactUsParagraph2_mobile' : 'ContactUsParagraph2'}
                parent="p"
                tOptions={{ skipPostProcessing: true }}
              />
              <Trans
                i18nKey={isMobile ? 'ContactUsParagraph3_mobile' : 'ContactUsParagraph3'}
                parent="p"
                tOptions={{ skipPostProcessing: true }}
              />
            </Col>
            <Col>
              <p className="copy text-center fw-bold mb-0">
                Telefon:{' '}
                <Clickable onClick={openCall}>
                  {t('headerPhoneSupportViewNumberToDisplay')}
                </Clickable>
                <br />
                E-Mail:{' '}
                <Clickable onClick={openEmail}>{t('pageCentralHeatingFallbackEMail')}</Clickable>
              </p>
            </Col>
          </Row>
        </TechemModalBody>
      }
      footer={
        <TechemModalButtonFooter
          primary={{
            text: t('closeModalText'),
            additionalTestId: 'close',
            handleOnClick: () => setOpen(false)
          }}
          trackClickUsingTestId={(buttonIdentifier) =>
            TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, modalId)
          }
        />
      }
    />
  );
};

export default MultipleHousesModal;
